<template>
  <div id="app">
    <!--<Editor />-->
    <router-view></router-view>
    <notifications group="foo" />
  </div>
</template>

<script>
// @ is an alias to /src
import "video.js/dist/video-js.css";
import "element-ui/lib/theme-chalk/display.css";

export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: var(--light-grey);
  height: 100vh;
}
@font-face {
  font-family: 'Poppins';
  font-weight: lighter;
  src: url('./assets/Poppins Font/PoppinsLight-l4Zw.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: bold;
  src: url('./assets/Poppins Font/PoppinsSemibold-8l8n.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: 500;
  src: url('./assets/Poppins Font/PoppinsMedium-1JPv.otf') format('opentype');
}
.el-dialog {
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>